import React, { useState, useCallback } from "react";
import "../Login.css";
import "../App.css";
import GoogleButton from "../components/GoogleButton/GoogleButton.jsx";
import MicrosoftButton from "../components/MicrosoftButton/MicrosoftButton.jsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "../authConfig.js";
import { useSessionExpiration } from "../hooks/useSessionExpiration.js"; // <--- Ton hook
import ToastNotification from "../components/ToastNotification.jsx";
import { useAuth } from "../context/AuthContext.js";

const msalInstance = new PublicClientApplication(msalConfig);
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Login = () => {
  const [loader, setLoader] = useState(false);
  const { toast, setToast, authMessage } = useAuth();
  const sessionDisplayed = useSessionExpiration();
  const [googleError, setGoogleError] = useState(null);
  const [microsoftError, setMicrosoftError] = useState(null);

  // Mémoïsés : les boutons les appellent dans un useEffect dépendant de onError.
  // Une erreur remise à null (nouvelle tentative) ne doit pas masquer le loader.
  const handleGoogleError = useCallback((error) => {
    setGoogleError(error);
    if (error) setLoader(false);
  }, []);

  const handleMicrosoftError = useCallback((error) => {
    setMicrosoftError(error);
    if (error) setLoader(false);
  }, []);

  const loginError = googleError || microsoftError || authMessage;

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          {/* Logo */}
          <div className="logo-container">
            <img src="/niralakka_logo.png" alt="Logo" width="300px" />
          </div>
          <p>Accédez à votre espace personnel</p>
        </div>

        {/* Message d'expiration de session */}
        {/* {sessionDisplayed && (
          <div className="session-expired-message">
            <div className="session-expired-icon">⚠️</div>
            <div className="session-expired-text">
              Votre session a expiré. Veuillez vous reconnecter.
            </div>
          </div>
        )} */}

        {/* Login options */}

        <div className="login-options">
          {loader && <div className="loader"></div>}

          {/* Les boutons restent montés pendant le chargement : leurs hooks
              doivent survivre pour remonter l'erreur de connexion. */}
          <div style={{ display: loader ? "none" : "contents" }}>
            <GoogleOAuthProvider clientId={clientId}>
              <GoogleButton
                onError={handleGoogleError}
                setLoader={setLoader}
              />
            </GoogleOAuthProvider>

            <MsalProvider instance={msalInstance}>
              <MicrosoftButton onError={handleMicrosoftError}  setLoader={setLoader}/>
            </MsalProvider>
          </div>
        </div>

        {/* Message d'erreur (connexion refusée, limitation de débit, session fermée par l'API) */}
        {loginError && (
          <div className="login-error-message" role="alert">
            <div className="login-error-icon">⚠️</div>
            <div className="login-error-text">
              {loginError}
            </div>
          </div>
        )}
        <div className="login-footer">
          <p>© Niralakka {new Date().getFullYear()}</p>
        </div>
      </div>

      {toast.visible && (
        <ToastNotification
          type={toast.type}
          message={toast.message}
          onClose={() => setToast({ ...toast, visible: false })}
        />
      )}
    </div>
  );
};

export default Login;
